<template>
  <path pid="0" d="M20 10a1 1 0 00-1 1v2a6 6 0 01-12 0v-2a1 1 0 00-2 0v2.25a8 8 0 007 7.69V23H9a1 1 0 000 2h8a1 1 0 001-1v-.12a1 1 0 00-1-.88h-3v-2.06A8 8 0 0021 13v-2a1 1 0 00-1-1z"/><path pid="1" d="M17 13V5a4 4 0 00-8 0v8a4 4 0 008 0zm-6 0V5a2 2 0 014 0v8a2 2 0 01-4 0z"/>
</template>
